<template>
    <v-flex>
      <v-layout row lg8
                  class="toolBox mb-2 common-form-search mb-4">
          <v-flex md2>
              <v-text-field placeholder="Search" hide-details single-line outline append-icon="search" v-model="searchKey"></v-text-field>
            
          </v-flex>
         
        </v-layout>

          <div v-if="messageLists && messageLists.length" class="message-card">
            <v-list subheader v-for="(item, index) in messageLists" :key="'list'+index">
              <v-subheader class="message-title">{{item.Key}}{{item.Unread>0?'('+item.Unread+')':''}}</v-subheader>
              <div class="">
                <template v-for="(piece, ind) in item.Items">
                  <v-list-tile :key="'subList'+ind" @click="turnDetail(piece.Index,piece.Text,piece.Desc,piece.Time,piece.isRead)">
                    <div class="pt-1 pr-3 imgPos" >
                      <img :src="messageIcon" />
                      <span class="spPos" v-if="!piece.isRead"></span> <!--  新增未读消息 -->
                    </div>
                    <v-list-tile-content >
                      <v-list-tile-title>{{ piece.Desc }}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-list-tile-sub-title v-if="piece.Time">{{ piece.Time | formatDate }}</v-list-tile-sub-title>
                      <v-list-tile-sub-title v-else>#{{piece.Index}}</v-list-tile-sub-title>
                    </v-list-tile-action>
                  </v-list-tile>
                </template>
              </div>
              
            </v-list>
           
          </div>

           <div v-if="messageLists && messageLists.length" class="text-xs-left pt-2">
              <v-pagination class="common-pagination"  v-model="currentPage"
                          :length="this.totlePage"
                          :total-visible="7"
                          ></v-pagination>
            </div>

          <v-flex v-if ="messageLists && !messageLists.length" class="text-xs-center">
            <div class="pl-5 pt-5 subheading blue-text-normal">No Data!</div>
          </v-flex>

          <v-flex v-if ="!messageLists" class="text-xs-center pt-5">
            <v-progress-circular indeterminate :size="30" color="grey"></v-progress-circular>
          </v-flex>
          
    </v-flex>
</template>
<script>
import { formatDate } from '@/utils/date.js'
import messageIcon from '@/assets/img/common/headerbar/panel-icon2.png'
import store from '@/store'
export default {
    data: () => ({
        currentPage: 0,
        searchKey: '',
        messageIcon: messageIcon
    }),
    props:{
        totlePage: Number,
        messageLists: Array,
        messageTitle: String,
        messageSubTitle: String,
        messageType: String
    },
    methods: {
        turnDetail (Id,Text,Desc,Time,show) {
          if(!show){
            let total=store.state.message.homeMsg.total-1
            if(this.messageType=='notice'){
              let noticeMsg=store.state.message.homeNoticeMsg.total-1
              store.dispatch('addHomeNoticeMsg', noticeMsg)
            }else if(this.messageType=='warning'){
              let warnMsg=store.state.message.homeWarnMsg.total-1
              store.dispatch('addHomeWarnMsg', warnMsg)
            }else if(this.messageType=='remind'){
              let remindMsg=store.state.message.homeRemindMsg.total-1
              store.dispatch('addHomeRemindMsg', remindMsg)
            }
            store.dispatch('addHomeMsg', total)
          }
          let messageType = this.messageType == 'remind' ? 'messageRemindView' : 'messageOtherView'
          if(Id==-1){
            this.$router.push({ name: messageType, params: { id: Id,title:Desc,content:Text,create_time:Time } })
          }else{
            sessionStorage.setItem('currentPage', this.currentPage);
            this.$router.push({ name: messageType, params: { id: Id } })
          }
        }
    },
    filters: {
        formatDate (time) {
          let date = new Date(time)
          return formatDate(date, 'MM-dd-yyyy hh:mm:ss')
        }
    },
    watch: {
      currentPage: function () {
        this.$emit('refreshList',this.searchKey,this.currentPage)
      },
      searchKey: function () {
        this.currentPage = 1 
        this.$emit('refreshList',this.searchKey,this.currentPage)
      }
    },
    mounted(){
      if(sessionStorage.getItem('msgInfo')){
    
        //如果有这个就读取缓存里面的数据
        this.currentPage = Number(sessionStorage.getItem("currentPage"));
      }else{
        this.currentPage=1;
        //这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
        sessionStorage.removeItem("currentPage");
      }
    },
    destroyed(){
       sessionStorage.removeItem("msgInfo");
    },
}
</script>
<style lang="scss" >
[data-theme="theme1"] .message-card .v-list--subheader{
  background: #1a1f32 !important;
}
[data-theme="theme1"] .message-card .v-list__tile:hover{
	background: #151827!important;
}
.message-card{
  background: #FFF !important;
  -webkit-box-shadow: 0px 0px 10px rgba(125, 162, 255, 0.19) !important;
  box-shadow: 0px 0px 10px rgba(125, 162, 255, 0.19) !important;
  border-radius: 16px !important;
  .v-list--subheader{
    padding-bottom: 0;
    &:first-child{
      .message-title{
        font-size: 20px;
        color: $blue-title-2!important;
        box-shadow: 0px 0px 10px rgba(125, 162, 255, 0.19);
        border-radius: 8px 8px 0px 0px;
        padding-left: 50px;
        height: 60px;
        font-weight: 600;
        letter-spacing: .6px;

      }
    }
    .message-title{
        font-size: 20px;
        color: $blue-title-2!important;
        padding-left: 50px;
        height: 60px;
        font-weight: 600;
        letter-spacing: .6px;
      }
  }

  .v-list__tile{
    padding: 0 50px;
		@include font_color($font-color-theme);
    letter-spacing: .4px;
    &:hover{
      background: #E9F4FF!important;
    }
  }
  .theme--light.v-list .v-list__tile__sub-title{
		@include font_color($font-color-theme);
    letter-spacing: .4px;
  }
}
.imgPos{
  position: relative;
}
.spPos{
  position: absolute;
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: red;
}

</style>
